<nz-modal [nzMaskClosable]="false"
          [nzWidth]="680"
          [nzVisible]="showPreviewModal"
          [nzTitle]="'附件列表'"
          (nzOnOk)="handleClosePreviewModal()"
          (nzOnCancel)="handleClosePreviewModal()">
  <div nz-row [nzGutter]='24' class="img-scroll">
    <div nz-col [nzSpan]='6' *ngFor="let image of cos?.fileList; let i=index">
      <div class="img-container m-b-10">
        <div class="image" *ngIf="image.fileDataType === 'img'">
          <img nz-tooltip [nzTooltipTitle]="'点击查看详情'"
               [src]="image.url" (click)="openPreview(i)" />
        </div>
        <div class="image" *ngIf="image.fileDataType === 'video'">
          <video autoplay="autoplay" loop nz-tooltip
                 [nzTooltipTitle]="'点击查看详情'"
                 (click)="openPreviewVideo(image)">
            <source [src]="image.url">
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div class="image" *ngIf="image.fileDataType === 'audio'">
          <audio controls [src]="image.url" class="audio">
            您的浏览器不支持 HTML5 audio 标签。
          </audio>
        </div>
<!--        <div *ngIf="image.fileDataType === 'pdf'" class="f-center">-->
<!--          <img style="width: 85%!important;height: 85%!important;" src="assets/images/pdf.png"/>-->
<!--        </div>-->
        <div class="image" *ngIf="image.fileDataType === 'other'">
          <a class="other" [href]="image.url" target="_blank">打开</a>
        </div>
        <div class="image" *ngIf="image.fileDataType !== 'img' && image.fileDataType !== 'video' && image.fileDataType !== 'audio'">
          <a class="file-link" [href]="image.url" rel="noopener" [attr.download]="getDownloadName(image)" target="_blank">
            <div class="image-bg" [ngStyle]="{ 'background-image': 'url(' + getFileIcon(image.fileDataType) + ')' }"></div>
          </a>
        </div>
        <div *abpPermission="'EasyAbp.FileManagement.File.Delete'" class='file-delete' (click)='confirmDeleteFile(cos.fileList, i)'><i class='icon iconfont icon-close'></i>
        </div>
        <div class='file-download' (click)="download(cos.fileList, i)"><i class="icon iconfont icon-import-file1"></i></div>
        <nz-spin *ngIf="image.fileDataType === 'loading'"></nz-spin>
      </div>
      <div>
        <a [href]="image.url" target="_blank" *ngIf="image.fileDataType !== 'img' && image.fileDataType !== 'video' && image.fileDataType !== 'audio'">{{image.name}}</a>
      </div>
    </div>

    <div nz-col [nzSpan]='6' *ngFor="let image of localCOS?.fileList; let i=index">
      <div class="img-container m-b-10">
        <div class="image" *ngIf="image.fileDataType === 'img'">
          <img nz-tooltip [nzTooltipTitle]="'点击查看详情'" [src]="image.url" (click)="openPreview(i)" />
        </div>
        <div class="image" *ngIf="image.fileDataType === 'video'">
          <video autoplay="autoplay" loop nz-tooltip
                 [nzTooltipTitle]="'点击查看详情'"
                 (click)="openPreviewVideo(image)">
            <source [src]="image.url">
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <div class="image" *ngIf="image.fileDataType === 'audio'">
          <audio controls [src]="image.url" class="audio">
            您的浏览器不支持 HTML5 audio 标签。
          </audio>
        </div>
        <div class="image" *ngIf="image.fileDataType === 'pdf'">
          <img style="width: 85%!important;height: 85%!important;" src="assets/images/pdf.png"/>
        </div>
        <div class="image" *ngIf="image.fileDataType === 'other'">
          <a [href]="image.url" target="_blank">打开</a>
        </div>
        <div *abpPermission="'EasyAbp.FileManagement.File.Delete'" class='file-delete' (click)='confirmDeleteFile(localCOS.fileList, i)' nz-tooltip nzTooltipTitle="删除">
          <i class='icon iconfont icon-close'></i>
        </div>
        <div class='file-download' (click)="download(localCOS.fileList, i)" nz-tooltip nzTooltipTitle="下载"><i class="icon iconfont icon-import-file1"></i></div>
        <nz-spin *ngIf="image.fileDataType === 'loading'"></nz-spin>
      </div>
      <div><a [href]="image.url" target="_blank" *ngIf="image.fileDataType === 'pdf' || image.fileDataType === 'other'">{{image.name}}</a></div>
    </div>
  </div>

</nz-modal>
<nz-modal
  nzWidth="760"
  [nzMaskClosable]="false"
  [(nzVisible)]="isShowVideoModal"
  [nzContent]="videoModalContent"
  [nzFooter]="videoModalFooter"
  (nzOnCancel)="closeVideoModal()"
>
  <ng-template #videoModalContent>
    <div class="video-container">
      <video controls="controls" autoplay="autoplay" loop style="width: 100%;height:680px;">
        <source [src]="videoInfo.url">
        您的浏览器不支持 HTML5 video 标签。
      </video>
    </div>
  </ng-template>
  <ng-template #videoModalFooter>
    <button nz-button class="modal-cancel-btn" (click)="closeVideoModal()">关 闭</button>
  </ng-template>
</nz-modal>
